<ng-container *transloco="let t">
  <h2 mat-dialog-title>{{ t('features.staffMonitor.trendDialog.title') }}</h2>

  @if (notEnoughData()) {
    <p class="text-center">{{ t('features.staffMonitor.trendDialog.notEnoughData') }}</p>
  } @else {
    <form>
      <mat-dialog-content>
        <mat-form-field class="name-width">
          <mat-label>{{ t('features.staffMonitor.trendDialog.graphUpperLimit') }}</mat-label>

          <input matInput type="number" [formControl]="maxLFControl" (keydown.enter)="$event.preventDefault()" />

          <mat-error>{{ maxLFControl.errors | validatorError }}</mat-error>
        </mat-form-field>
      </mat-dialog-content>
    </form>

    <div class="lf-container relative">
      @if (loading()) {
        <app-mind-spinner />
      }
      @let optionsValue = options();
      @let componentOptionsValue = componentOptions();
      @let framesValue = frames();
      @if (!(optionsValue | isNil) && !(componentOptionsValue | isNil) && !(framesValue | isNil)) {
        <app-mind-uplot-playback
          #trendUplot
          [componentOptions]="componentOptionsValue"
          [frames]="framesValue"
          [options]="optionsValue"
        />
      }
    </div>
  }

  <mat-dialog-actions align="center">
    <button mat-button type="button" (click)="close()">
      {{ t('common.close') }}
    </button>
  </mat-dialog-actions>
</ng-container>
